import type { ThemeDefinition } from 'vuetify';

const orange = '#F47920';
const green = '#00B695';
const yellow = '#ffd059';
const blue = '#369eff';
const red = '#C9252C';
const cyan = '#1DFEF8';
const pointPink = '#EB1368';
const purple = '#8A38F5';
const darkBlue = '#152130';
const onDarkBlue = '#E0E0E0';
const mainBlue = '#0054a6';
const richBlue = '#003471';

const onSceneBackground = '#9e9e9e'

/**
 * Dark backdrop the 3D canvas clears to. Exported so the Three.js
 * `DEFAULT_CLEAR_COLOR` in `lib/threeScene/renderingState.ts` can share the
 * value with the CSS theme entry below (Three.js can't read CSS variables).
 */
export const SCENE_BACKGROUND = '#262625';

export const formusLightTheme: ThemeDefinition = {
    dark: false,
    colors: {

        green: green,
        'green-hover': '#0D9174',

        'yellow' : yellow,

        'grey-1': '#99a4ac',
        'grey-light': '#D9D9D9',
        'grey-light-1': '#d2dcdf',


        'planner-surface': onDarkBlue,
        'on-planner-surface': darkBlue,
        'outline': '#C1C7CE',
        'on-increment-grey': '#d2dcdf',

        orange: orange,
        'orange-hover': '#EA6301',

        red: red,
        'red-hover': '#AD040C',

        cyan: cyan,
        'point-pink': pointPink,
        purple: purple,

        // ===============================
        //
        // Semantic colors
        //
        // =================================
        background: '#F0F2F5',

        surface: '#ffffff',
        'on-surface': '#262626',
        'surface-light': '#F8F8F8',

        primary: blue,
        secondary: '#7C8893',
        'main-blue': mainBlue,
        'rich-blue': richBlue,

        caution: yellow,
        error: red,
        info: blue,
        success: green,
        warning: orange,

        'call-to-action': green,

        'dark-blue': darkBlue,
        'dark-background': darkBlue,
        'on-dark-background': onDarkBlue,
        'secondary-text': '#3D4D5C',

        'scene-background': SCENE_BACKGROUND,
        'on-scene-background': onSceneBackground,

        white: '#ffffff',
        black: '#3a3e42'
    },
    variables: {
        // We can add CSS variables here (See 'https://developer.mozilla.org/en-US/docs/Web/CSS/--*')
        'v-text-field-border-radius': '22px',
        'v-text-field-border-color': 'rgb(var(--v-theme-grey-light-1))',
        // Subtle separator on dark surfaces (e.g. the CT slider row's
        // bottom edge). Alpha is baked in so the call site doesn't decide it.
        'on-dark-divider': 'rgba(255, 255, 255, 0.15)',
    },
} as const;
